import { cn } from "@/lib/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinnerThird } from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { AnimatePresence, motion } from "framer-motion";
import { createPortal } from "react-dom";

type LoadingOverlayProps = {
  loading: boolean;
  title?: string | null;
  description?: string | null;
};

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  loading,
  title = "Loading",
  description,
}) => {
  return createPortal(
    <AnimatePresence>
      {loading && (
        <motion.div
          className={cn(
            "bg-background-5/80 fixed inset-0 z-1005 flex items-center justify-center backdrop-blur-xs",
          )}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div className="flex flex-row items-center gap-4">
            <FontAwesomeIcon
              icon={faSpinnerThird}
              size="5x"
              className="animate-[spin_1s_linear_infinite]"
            />
            <div className="flex flex-col gap-1 font-bold">
              <div className="text-foreground-8 text-2xl font-bold">
                {title}...
              </div>
              {description && (
                <div className="text-foreground-5 text-lg italic">
                  {description}
                </div>
              )}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body,
  );
};
